import ConfigsPage from './ConfigsPage.container';

export default ConfigsPage;
